import React from 'react';

import { Card, Col } from "react-bootstrap";

import Loading from '../Loading';

const CardInfoUser = (props) => {
    const {colSize, load} = props;
    return ( 
        <Col lg={colSize}>
            <Card className="shadow mb-4">
                <Card.Header className="card-header py-3 m-0 font-weight-bold text-primary">Perfil</Card.Header>
                <Card.Body>
                    <Card.Title>Datos Personal</Card.Title>
                    <hr />
                    <Card.Text>
                        {load ? 
                            <Loading /> : 
                            props.children
                        }
                    </Card.Text>
                    
                </Card.Body>
                <Card.Footer>
                    {load ? '-' : <small className="text-muted">Last updated 3 mins ago</small> }
                </Card.Footer>
            </Card>
    </Col>               
     );
}
 
export default CardInfoUser;